import { FilterSelect } from '@/components/ui/filter-select'

import { useInventoryLocations } from '../hooks'
import { inOutletOrder, locationLabel } from './inventory-format'

interface LocationFilterProps {
  value: string | null
  onChange: (locationId: string | null) => void
  isDisabled?: boolean
}

/**
 * Whose stock the table shows: every location's total, or one location's.
 *
 * One location at a time, unlike the outlet filter elsewhere in the app. The
 * stock read takes a single location, and a sum over a hand-picked three is a
 * number no shelf holds — the totals already answer "how much do we have".
 *
 * Always drawn, like the branch pickers, so the bar does not shift once the list
 * arrives. With no locations yet it offers only "All locations", which is still
 * the truth about what the table shows.
 */
export function LocationFilter({ value, onChange, isDisabled }: LocationFilterProps) {
  const { locations } = useInventoryLocations()

  return (
    <FilterSelect
      label="Location"
      allLabel="All locations"
      triggerClassName="w-48"
      isDisabled={isDisabled}
      value={value}
      options={inOutletOrder(locations).map((location) => ({
        value: location.id,
        label: locationLabel(location),
      }))}
      onChange={onChange}
    />
  )
}
